import 'css-chunksrc/client/common/layout/zonesList/loader/styles.scss';export default {
  "zonesList": "_zonesList_19a8s_1",
  "item": "_item_19a8s_6",
  "header": "_header_19a8s_18",
  "activeZones": "_activeZones_19a8s_27",
  "zoneCreation": "_zoneCreation_19a8s_31",
  "selectedZone": "_selectedZone_19a8s_35",
  "name": "_name_19a8s_39",
  "addZoneButton": "_addZoneButton_19a8s_44",
  "closed": "_closed_19a8s_51",
  "loader": "_loader_19a8s_70",
  "loaderMain": "_loaderMain_19a8s_78"
};